<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <!-- Global notification live region, render this permanently at the end of the document -->
  <div aria-live="assertive" class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-50">
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
      <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
      <transition enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <div v-if="$store.state.notification.show" class="notification-panel bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <CheckCircleIcon class="h-6 w-6 text-green-400" aria-hidden="true" v-if="$store.state.notification.success === true" />
                <BanIcon class="h-6 w-6 text-red-400" aria-hidden="true" v-if="$store.state.notification.success === false"/>
              </div>
              <div class="ml-3 min-w-0 flex-1 pt-0.5">
                <div class="flex items-start justify-between gap-x-3">
                  <p class="notification-text text-sm font-medium text-gray-900">{{$store.state.notification.head}}</p>
                  <span v-if="totalNotifications > 1" class="flex-shrink-0 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-500">
                    1/{{ totalNotifications }}
                  </span>
                </div>
                <p class="notification-text mt-1 text-sm text-gray-500">{{$store.state.notification.subheader}}</p>
                <p v-if="queueLength > 0" class="mt-2 text-xs font-medium text-gray-400">
                  {{ queueLength }} {{ queueLabel }} w kolejce
                </p>
              </div>
              <!-- <div class="ml-4 flex-shrink-0 flex">
                <button @click.prevent="show = false" class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                  <span class="sr-only">Close</span>
                  <XIcon class="h-5 w-5" aria-hidden="true" />
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { CheckCircleIcon,BanIcon } from '@heroicons/vue/outline'
import { XIcon } from '@heroicons/vue/solid'

export default {
  components: {
    CheckCircleIcon,
    BanIcon,
    XIcon,
  },
  computed: {
    queueLength() {
      return this.$store.state.notificationQueue.length;
    },
    totalNotifications() {
      return this.queueLength + 1;
    },
    queueLabel() {
      if(this.queueLength === 1) return "notyfikacja";
      if(this.queueLength > 1 && this.queueLength < 5) return "notyfikacje";
      return "notyfikacji";
    },
  },
}
</script>

<style scoped>
.notification-panel {
  width: 380px;
  max-width: calc(100vw - 2rem);
}

.notification-text {
  overflow-wrap: anywhere;
  word-break: break-word;
}
</style>
